import {saveData, getData, clearData, findByID} from "../db/db_helper"

//load from DB
export const getOnlineExtras = async () =>{
    return await getData("extras") || []
}

export const getOffllineExtras = async () =>{
    return await getData("sync_extras") || []
}

export const getAllExtras = async () =>{
    const online = await getOnlineExtras()
    const offline = await getOffllineExtras()
    const all = [...online, ...offline]
    return all.sort((a, b) => new Date(b.startTime) - new Date(a.startTime));
}

export const getExtraById = async(id)=>{
    const online = await findByID("extras", id)
    const offline = await findByID("sync_extras", id)
    return online || offline || null
}

export const saveExtras = async (obj) =>{
    saveData("extras", obj)
}